import { render, staticRenderFns } from "./HistoryOrder.vue?vue&type=template&id=b3a33e0c&scoped=true&lang=pug&"
import script from "./HistoryOrder.vue?vue&type=script&lang=js&"
export * from "./HistoryOrder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryOrder.vue?vue&type=style&index=0&id=b3a33e0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a33e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VExpandTransition,VRow})
